/*
 * The permission_role enum, mirrored from the rails User model
 * (photographer|enterprise_admin|super_admin|lapsed|pro|lite|plus). The integer
 * values are the DB enum positions and are what the admin endpoints expect:
 *   - GET /api/v3/admin/users `role` filter takes the INTEGER.
 *   - POST /api/v3/admin/users `permission_role` takes the integer; the create
 *     path excludes `lapsed` (3) — admins don't hand-assign the lapsed state.
 * The list rows return only id/name/email (no role), so role display happens on
 * the detail screen, where permission_role comes back as the STRING label.
 */

export const ROLE_OPTIONS = [
  { value: 0, key: "photographer", label: "Photographer" },
  { value: 1, key: "enterprise_admin", label: "Enterprise Admin" },
  { value: 2, key: "super_admin", label: "Super Admin" },
  { value: 3, key: "lapsed", label: "Lapsed" },
  { value: 4, key: "pro", label: "Pro" },
  { value: 5, key: "lite", label: "Lite" },
  { value: 6, key: "plus", label: "Plus" },
];

// Roles an admin may assign when creating a user — everything except `lapsed`,
// which is a derived/lifecycle state, not a hand-set one (matches the rails
// create permit's enum [0,1,2,4,5,6]).
export const ASSIGNABLE_ROLE_OPTIONS = ROLE_OPTIONS.filter(
  (r) => r.key !== "lapsed"
);

// Map the enum STRING label (as returned on the detail endpoint) to a
// human-readable display label. Falls back to the raw value so an unknown role
// is visible rather than blank.
export const roleLabel = (roleKey) => {
  const match = ROLE_OPTIONS.find((r) => r.key === roleKey);
  return match ? match.label : roleKey || "—";
};
